/**
@format
@flow
*/
import * as React from 'react';
import { SubJumbo as KrispySubJumbo } from '@krispy/typography/web';
import Colors from '@ziynx/theme/colors';

type Props = $ReadOnly<{|
    /**
     * Extra large font size
     */
    extraLarge?: boolean,

    /**
     * Large font size
     */
    large?: boolean,

    /**
     * Medium font size
     */
    medium?: boolean,

    /**
     * Small font size
     */
    small?: boolean,

    /**
     * Color for body text
     */
    color?: string,

    /**
     * Primitive types
     */
    primitive?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',

    /**
     * Text
     */
    children: any,
  |}>;

/**
   * SubJumbo component
   */
const SubJumbo = (props: Props): React$Node => {
  const { color, children, ...rest } = props;

  return (
    <KrispySubJumbo color={color} {...rest}>
      {children}
    </KrispySubJumbo>
  );
};

SubJumbo.defaultProps = {
  color: Colors.GrayVeryDark,
  primitive: 'p',
};

export default SubJumbo;
